import { ReactNode } from "react";
import {
  isOneOnOneItem,
  isSelfStudyItem,
  periodToString,
  PricingModelItem,
} from "../../../model/pricingmodel";
import { HStack, VStack } from "../../Stack";
import Button from "../../formElements/Button/Button";
import { useTranslation } from "react-i18next";

export default function Submit({
  pricingItem,
  hdSubmit,
  children,
}: {
  pricingItem: PricingModelItem;
  hdSubmit: (evt: any) => void;
  children?: ReactNode;
}) {
  const { t } = useTranslation();
  const dueValue = isSelfStudyItem(pricingItem)
    ? `${pricingItem.price}/${periodToString(pricingItem.length!)}`
    : `${pricingItem.price}`;
  return (
    <VStack style={{ marginTop: "16px" }} gap={16} align="stretch" justify="flex-start">
      <HStack justify="flex-end" align={"flex-end"} className="due-container">
        <span>TOTAL DUE:</span>
        <span className="due-value">${dueValue}</span>
      </HStack>
      <Button className="btn submit-payment" type="submit" onClick={hdSubmit}>
        {t("Common.Checkout with Credit/Debit Card")}
      </Button>
      {children}
      {isSelfStudyItem(pricingItem) && (
        <p className="legal-warning">
          By subscribing to our ${dueValue} plan, you allow automatic charges
          {isSelfStudyItem(pricingItem) && ` ${periodToString(pricingItem.length!)}ly`}.
          The subscription renews automatically unless canceled in settings; no refunds
          for unused parts. Failed payments lead to notifications; after three tries, your
          subscription may end. Prices can change with a 30-day notice, and we may suspend
          or end accounts as needed.
        </p>
      )}
      {isOneOnOneItem(pricingItem) && (
        <p className="legal-warning">
          By making a one-time payment of ${dueValue}, you acknowledge the terms. Talaera
          has a 24-hour cancellation policy and holds the right to charge the full amount
          for any sessions that are canceled, missed, or rescheduled within 24 hours prior
          to the scheduled start time. All sales of Talaera products including, but not
          limited to 1:1 sessions, group sessions, workshops, and webinars are final and
          non-refundable. Failure to use product(s) does not constitute a basis to pay any
          of the associated charges.
        </p>
      )}
    </VStack>
  );
}
